import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import clsx from 'clsx';
import MenuItem from '@material-ui/core/MenuItem';

const Option = forwardRef(function Option(props, ref) {
  const {
    alignItems,
    children,
    className,
    dense,
    disabled,
    disableGutters,
    divider,
    selected,
    tabIndex,
    ...restProps // the Select parent injects all kinds of other props we don't need to expose or check
  } = props;

  return (
    <MenuItem
      {...restProps}
      alignItems={alignItems}
      className={clsx(className)}
      dense={dense}
      disabled={disabled}
      disableGutters={disableGutters}
      divider={divider}
      ref={ref}
      selected={selected}
      tabIndex={tabIndex}
    >
      {children}
    </MenuItem>
  );
});

Option.propTypes = {
  children: Proptypes.node.isRequired,
  alignItems: Proptypes.oneOf(['flex-start', 'center']),
  className: Proptypes.string,
  dense: Proptypes.bool,
  disabled: Proptypes.bool,
  disableGutters: Proptypes.bool,
  divider: Proptypes.bool,
  selected: Proptypes.bool,
  tabIndex: Proptypes.number,
};

Option.defaultProps = {
  alignItems: 'center',
  className: '',
  dense: true,
  disabled: false,
  disableGutters: false,
  divider: false,
  selected: false,
  tabIndex: -1,
};

Option.displayName = 'Option';

export default Option;
